module.exports = __webpack_public_path__ + "static/fonts/aeonik-light.8a92f7b1.woff";